import { z } from 'zod';
export const mergeRequestParamsSchema = z.object({
    auto_claim: z.boolean().default(false),
});

export type mergeRequestParamsType = z.infer<typeof mergeRequestParamsSchema>;

export const defaultMergeRequestParams = mergeRequestParamsSchema.parse({});
